<template>
  <div
    id="inst-quiz-modal"
    class="modal fade choose-quiz-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="inst-quiz-modal-label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div
        class="modal-content border-0"
        :class="{ 'result-content': currentStep === 4 }"
      >
        <!-- Modal header -->
        <div class="modal-header border-0 d-block">
          <div class="d-flex flex-column heading-close-container">
            <div
              class="progress-close-container"
              :class="{ 'justify-content-end': currentStep === 4 }"
            >
              <div v-if="currentStep <= 3" class="progress-step-bar">
                <div class="step-line filled" />
                <div class="step-line" :class="{ filled: currentStep >= 2 }" />
                <div class="step-line" :class="{ filled: currentStep >= 3 }" />
              </div>
              <button
                ref="quizModalCloseBtnRef"
                qid="instiReq-5"
                class="btn close-btn m-0"
                :aria-label="
                  $t('ONBOARDING.INSTITUTION_REQUEST.SCREEN_READER.CLOSE')
                "
                data-bs-dismiss="modal"
              >
                <ClientOnly>
                  <nuxt-icon
                    loading="lazy"
                    name="cross-icon"
                    class="close-icon"
                    aria-hidden="true"
                  />
                </ClientOnly>
                <span class="sr-only">{{
                  $t('ONBOARDING.INSTITUTION_REQUEST.SCREEN_READER.CLOSE')
                }}</span>
              </button>
            </div>
            <h3 id="inst-quiz-modal-label" class="modal-title text-center">
              <span v-if="currentStep <= 3">{{
                $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_HEADING')
              }}</span>
              <span v-else>{{
                $t('ONBOARDING.INSTITUTION_REQUEST.RESULT')
              }}</span>
            </h3>
          </div>
        </div>

        <!-- Modal body -->
        <div
          class="modal-body"
          :class="{
            'result-body': currentStep === 4,
            'independent-result-body':
              currentStep === 4 && quizResult.independentTeacherResult,
            'loading-result-body':
              currentStep === 4 && !quizResult.resultsCalculated
          }"
        >
          <form v-if="currentStep <= 3" id="quizForm" ref="quizFormRef">
            <ol
              v-if="currentStep === 1"
              type="1"
              class="question-list-container"
              role="none"
            >
              <li class="question-list" @click="handleCheckboxClick">
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_1')
                  }}
                  <div class="question-sub-heading">
                    {{
                      $t(
                        'ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_SUBHEADING_1'
                      )
                    }}
                  </div>
                </div>
                <div class="d-flex flex-column question-answer">
                  <input
                    id="ageRange_1"
                    v-model="quizData.ageRanges"
                    type="checkbox"
                    class="checkbox-input"
                    :name="institutionQuizTypes.ageRanges.name"
                    :value="institutionQuizTypes.ageRanges.values.primary"
                  />
                  <label for="ageRange_1" class="checkbox-label">
                    <span class="checkbox-label-text">
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_ANSWER_1_1') }}
                    </span>
                  </label>
                  <input
                    id="ageRange_2"
                    v-model="quizData.ageRanges"
                    type="checkbox"
                    class="checkbox-input"
                    :name="institutionQuizTypes.ageRanges.name"
                    :value="institutionQuizTypes.ageRanges.values.secondary"
                  />
                  <label for="ageRange_2" class="checkbox-label">
                    <span class="checkbox-label-text">
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_ANSWER_1_2') }}
                    </span>
                  </label>
                  <input
                    id="ageRange_3"
                    v-model="quizData.ageRanges"
                    type="checkbox"
                    class="checkbox-input"
                    :name="institutionQuizTypes.ageRanges.name"
                    :value="institutionQuizTypes.ageRanges.values.adult"
                  />
                  <label for="ageRange_3" class="checkbox-label">
                    <span class="checkbox-label-text">
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_ANSWER_1_3') }}
                    </span>
                  </label>
                </div>
              </li>
              <li
                class="question-list"
                @click="handleRadioClick"
                @keyup.enter.space="handleRadioClick"
              >
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_2')
                  }}
                </div>
                <div class="d-flex question-answer radio-question">
                  <input
                    id="independentSignup_1"
                    v-model="quizData.independentSignup"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.independentSignup.name"
                    :value="institutionQuizTypes.independentSignup.values.Yes"
                  />
                  <label
                    tabindex="0"
                    for="independentSignup_1"
                    class="radio-label"
                  >
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.YES') }}
                  </label>
                  <input
                    id="independentSignup_2"
                    v-model="quizData.independentSignup"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.independentSignup.name"
                    :value="institutionQuizTypes.independentSignup.values.No"
                  />
                  <label
                    tabindex="0"
                    for="independentSignup_2"
                    class="radio-label"
                  >
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.NO') }}
                  </label>
                </div>
              </li>
            </ol>
            <ol
              v-if="currentStep === 2"
              type="1"
              class="question-list-container"
              start="3"
              role="none"
            >
              <li
                class="question-list"
                @click="handleRadioClick"
                @keyup.enter.space="handleRadioClick"
              >
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_3')
                  }}
                </div>
                <div class="d-flex question-answer radio-question">
                  <input
                    id="createClasses_1"
                    v-model="quizData.createClasses"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.createClasses.name"
                    :value="institutionQuizTypes.createClasses.values.OneByOne"
                  />
                  <label tabindex="0" for="createClasses_1" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.ONE_BY_ONE') }}
                  </label>
                  <input
                    id="createClasses_2"
                    v-model="quizData.createClasses"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.createClasses.name"
                    :value="institutionQuizTypes.createClasses.values.Bulk"
                  />
                  <label tabindex="0" for="createClasses_2" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.BULK') }}
                  </label>
                </div>
              </li>
              <li
                class="question-list"
                @click="handleRadioClick"
                @keyup.enter.space="handleRadioClick"
              >
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_4')
                  }}
                </div>
                <div class="d-flex question-answer radio-question">
                  <input
                    id="copyFromExisting_1"
                    v-model="quizData.copyFromExisting"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.copyFromExisting.name"
                    :value="institutionQuizTypes.copyFromExisting.values.Yes"
                  />
                  <label
                    tabindex="0"
                    for="copyFromExisting_1"
                    class="radio-label"
                  >
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.YES') }}
                  </label>
                  <input
                    id="copyFromExisting_2"
                    v-model="quizData.copyFromExisting"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.copyFromExisting.name"
                    :value="institutionQuizTypes.copyFromExisting.values.No"
                  />
                  <label
                    tabindex="0"
                    for="copyFromExisting_2"
                    class="radio-label"
                  >
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.NO') }}
                  </label>
                </div>
              </li>
            </ol>
            <ol
              v-if="currentStep === 3"
              type="1"
              class="question-list-container"
              start="5"
              role="none"
            >
              <li
                class="question-list"
                @click="handleRadioClick"
                @keyup.enter.space="handleRadioClick"
              >
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_5')
                  }}
                </div>
                <div class="d-flex question-answer radio-question">
                  <input
                    id="gradingScales_1"
                    v-model="quizData.gradingScales"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.gradingScales.name"
                    :value="
                      institutionQuizTypes.gradingScales.values.UseDefault
                    "
                  />
                  <label tabindex="0" for="gradingScales_1" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.USE_DEFAULT') }}
                  </label>
                  <input
                    id="gradingScales_2"
                    v-model="quizData.gradingScales"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.gradingScales.name"
                    :value="
                      institutionQuizTypes.gradingScales.values.CreateMyOwn
                    "
                  />
                  <label tabindex="0" for="gradingScales_2" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.CREATE_MY_OWN') }}
                  </label>
                </div>
              </li>
              <li
                class="question-list"
                @click="handleRadioClick"
                @keyup.enter.space="handleRadioClick"
              >
                <div class="question-heading">
                  {{
                    $t('ONBOARDING.INSTITUTION_REQUEST.QUIZ_QUESTION_HEADING_6')
                  }}
                </div>
                <div class="d-flex question-answer radio-question">
                  <input
                    id="runReport_1"
                    v-model="quizData.runReport"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.runReport.name"
                    :value="institutionQuizTypes.runReport.values.Yes"
                  />
                  <label tabindex="0" for="runReport_1" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.YES') }}
                  </label>
                  <input
                    id="runReport_2"
                    v-model="quizData.runReport"
                    tabindex="-1"
                    type="radio"
                    class="radio-input"
                    :name="institutionQuizTypes.runReport.name"
                    :value="institutionQuizTypes.runReport.values.No"
                  />
                  <label tabindex="0" for="runReport_2" class="radio-label">
                    {{ $t('ONBOARDING.INSTITUTION_REQUEST.NO') }}
                  </label>
                </div>
              </li>
            </ol>
          </form>
          <div v-else class="result">
            <template v-if="quizResult.resultsCalculated">
              <h2 class="result-heading">
                <span v-if="!quizResult.independentTeacherResult">
                  {{
                    $t(
                      'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_HEADING.PART_1'
                    )
                  }}
                  <strong>{{
                    $t(
                      'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_HEADING.STRONG_TEXT'
                    )
                  }}</strong>
                  {{
                    $t(
                      'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_HEADING.PART_2'
                    )
                  }}
                </span>
                <span v-else>
                  {{
                    $t(
                      'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_INDEPENDENT_HEADING.PART_1'
                    )
                  }}
                  <strong>{{
                    $t(
                      'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_INDEPENDENT_HEADING.STRONG_TEXT'
                    )
                  }}</strong>
                  <template v-if="locale === 'En'">
                    {{
                      $t(
                        'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_INDEPENDENT_HEADING.PART_2'
                      )
                    }}
                  </template>
                </span>
              </h2>

              <!-- image -->
              <ClientOnly>
                <nuxt-icon
                  loading="lazy"
                  name="institution-request-icon"
                  class="institution-request-icon"
                  aria-hidden="true"
                />
              </ClientOnly>

              <p class="result-description">
                <span v-if="!quizResult.independentTeacherResult">
                  <span class="result-description-heading">
                    {{
                      $t(
                        'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_HEADING'
                      )
                    }}
                  </span>
                  <ul>
                    <li>
                      {{
                        $t(
                          'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_1'
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_2'
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_3'
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_4'
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_SCHOOL_ACCOUNT_DESCRIPTION_5'
                        )
                      }}
                    </li>
                  </ul>
                </span>
                <span v-else>
                  <span class="result-description-heading">
                    {{
                      $t(
                        'ONBOARDING.INSTITUTION_REQUEST.QUIZ_RESULT_INDEPENDENT_DESCRIPTION_HEADING'
                      )
                    }}
                  </span>
                </span>
              </p>
            </template>
            <template v-else>
              <div class="loader-wrapper">
                <div class="loader" />
              </div>
            </template>
          </div>
        </div>

        <!-- Modal Footer -->
        <div
          class="modal-footer px-0 pb-0"
          :class="{
            'justify-content-between': currentStep <= 3,
            'result-footer justify-content-center': currentStep === 4
          }"
        >
          <template v-if="currentStep <= 3">
            <button
              href="javascript:void(0);"
              class="back-btn"
              qid="instiReq-6"
              @click="handlePreviousStep"
            >
              <ClientOnly>
                <nuxt-icon
                  loading="lazy"
                  name="arrow-left-purple"
                  class="arrow-left-icon"
                  aria-hidden="true"
                />
              </ClientOnly>
              <span>{{
                $t('ONBOARDING.INSTITUTION_REQUEST.SCREEN_READER.BACK')
              }}</span>
            </button>
            <button
              v-if="currentStep < 3"
              class="btn btn-main-color-1-bordered next-btn"
              :disabled="
                (currentStep === 1 &&
                  (!quizData.ageRanges.length ||
                    !quizData.independentSignup)) ||
                (currentStep === 2 &&
                  (!quizData.createClasses || !quizData.copyFromExisting))
              "
              qid="instiReq-7"
              @click="handleNextStep"
            >
              <span>{{ $t('ONBOARDING.INSTITUTION_REQUEST.NEXT') }}</span>
              <ClientOnly>
                <nuxt-icon
                  loading="lazy"
                  name="angle-right-solid"
                  class="angle-right-icon"
                  aria-hidden="true"
                />
              </ClientOnly>
            </button>
            <button
              v-else
              class="btn btn-main-color-1-bordered finish-btn"
              qid="instiReq-8"
              :disabled="
                currentStep === 3 &&
                (!quizData.gradingScales || !quizData.runReport)
              "
              @click="handleFinishClick"
            >
              <span>{{ $t('ONBOARDING.INSTITUTION_REQUEST.FINISH') }}</span>
              <ClientOnly>
                <nuxt-icon
                  loading="lazy"
                  name="angle-right-solid"
                  class="angle-right-icon"
                  aria-hidden="true"
                />
              </ClientOnly>
            </button>
          </template>
          <template v-else>
            <button
              href="javascript:void(0);"
              class="footer-close-btn"
              qid="instiReq-8"
              :aria-label="
                $t('ONBOARDING.INSTITUTION_REQUEST.SCREEN_READER.CLOSE')
              "
              data-bs-dismiss="modal"
            >
              <ClientOnly>
                <nuxt-icon
                  loading="lazy"
                  name="xmark-solid"
                  class="close-icon"
                  aria-hidden="true"
                />
              </ClientOnly>
              <span>{{
                $t('ONBOARDING.INSTITUTION_REQUEST.SCREEN_READER.CLOSE')
              }}</span>
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n();
const institutionQuizTypes = {
  ageRanges: {
    name: 'ageRanges',
    values: {
      primary: 'Primary',
      secondary: 'Secondary',
      adult: 'Adult'
    },
    independentAccountResult: 'Adult'
  },
  independentSignup: {
    name: 'independentSignup',
    values: {
      Yes: 'Yes',
      No: 'No'
    },
    independentAccountResult: 'Yes'
  },
  createClasses: {
    name: 'createClasses',
    values: {
      OneByOne: 'One by one',
      Bulk: 'Bulk'
    },
    independentAccountResult: 'One by one'
  },
  copyFromExisting: {
    name: 'copyFromExisting',
    values: {
      Yes: 'Yes',
      No: 'No'
    },
    independentAccountResult: 'No'
  },
  gradingScales: {
    name: 'gradingScales',
    values: {
      UseDefault: 'Use default',
      CreateMyOwn: 'Create my own'
    },
    independentAccountResult: 'Use default'
  },
  runReport: {
    name: 'runReport',
    values: {
      Yes: 'Yes',
      No: 'No'
    },
    independentAccountResult: 'No'
  }
};
const quizModalCloseBtnRef = ref(null);
const quizData = ref({
  ageRanges: [],
  independentSignup: '',
  createClasses: '',
  copyFromExisting: '',
  gradingScales: '',
  runReport: ''
});
const currentStep = ref(1);
const quizResult = ref({
  resultsCalculated: false,
  independentTeacherResult: false
});

const handleRadioClick = (e) => {
  if (e.target.tagName === 'LABEL') {
    const radioInput = e.target.previousElementSibling;
    radioInput.checked = true;
    quizData.value[radioInput.name] = radioInput.value;
  }
};

const handleCheckboxClick = (e) => {
  if (e.target.tagName === 'INPUT') {
    if (e.target.checked) {
      quizData.value[e.target.name].push(e.target.value);
    } else {
      quizData.value[e.target.name] = quizData.value[e.target.name].filter(
        (value) => value !== e.target.value
      );
    }
  }
};

const handleCloseQuizModal = () => {
  quizModalCloseBtnRef.value.click();
};

const handleNextStep = () => {
  currentStep.value = Math.min(currentStep.value + 1, 3);
};

const handlePreviousStep = () => {
  if (currentStep.value === 1) {
    handleCloseQuizModal();
    return;
  }
  currentStep.value = Math.max(currentStep.value - 1, 1);
};

const handleFinishClick = () => {
  currentStep.value = 4;
  calculateQuizResult();
};

const calculateQuizResult = () => {
  if (
    Object.keys(institutionQuizTypes).every(
      (key) =>
        quizData.value[key] ===
          institutionQuizTypes[key].independentAccountResult ||
        (Array.isArray(quizData.value[key]) &&
          quizData.value[key].includes(
            institutionQuizTypes[key].independentAccountResult
          ) &&
          quizData.value[key].length === 1)
    )
  ) {
    quizResult.value.independentTeacherResult = true;
  }
  quizResult.value.resultsCalculated = true;
};
</script>
<style lang="scss" scoped>
.choose-quiz-modal {
  .modal-dialog {
    margin: 0.5rem auto;
    @include media-breakpoint-up(md) {
      margin: 1.75rem auto;
      max-width: 520px;
    }
    @include media-breakpoint-down(sm) {
      margin: 1.75rem auto;
      max-width: calc(100% - 24px);
    }
    .modal-content {
      padding: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 24px -6px rgba(0, 0, 0, 0.25);
      border: 0 none;
      @include media-breakpoint-down(sm) {
        height: 682px;
        border-radius: 8px;
        &.result-content {
          height: auto;
          .modal-title {
            padding-top: 0px !important;
          }
        }
      }
      .modal-header {
        border: 0 none;
        padding: 0 0 16px 0;
        .progress-close-container {
          display: flex;
          justify-content: space-between;
          margin-left: calc((100% - 390px) / 2);
          @include media-breakpoint-down(sm) {
            margin-left: calc((100% - 207px) / 2);
          }
          .progress-step-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            .step-line {
              width: 114px;
              height: 4px;
              background-color: #d9d9d9;
              margin: 0 8px;
              position: relative;
              border-radius: 2px;
              overflow: hidden;
              transition: background-color 0.2s;
              @include media-breakpoint-down(sm) {
                width: 53px;
              }
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 0;
                background-color: var(--cup-main-color-3);
                transition: width 0.2s ease-in-out;
              }
            }
            .step-line.filled::before {
              width: 100%;
            }
          }
        }

        .modal-title {
          padding-top: 16px;
          margin: 0 18% 0 18%;
          font-size: 16px;
          font-weight: bold;
          line-height: 24px;
          color: var(--cup-general-color-5);
        }
        .close-btn {
          align-items: center;
          display: flex;
          padding: 0;
          background: transparent;
          border: none;
          border-radius: unset;
          box-shadow: none;
          height: 24px;
          justify-content: center;
          width: 24px;
          .close-icon {
            font-size: 24px;
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
      }
      .modal-body {
        position: relative;
        height: 416px;
        padding: 12px 36px 0 36px;
        margin-bottom: 8px;
        &.result-body {
          padding-top: 0px;
          height: auto;
          margin-bottom: 24px;
        }
        &.independent-result-body {
          .result-description {
            text-align: center !important;
          }
        }
        &.loading-result-body {
          height: 100px;
        }
        @include media-breakpoint-down(md) {
          padding-right: 24px;
          padding-left: 24px;
        }
        @include media-breakpoint-down(sm) {
          padding: 0;
          &.result-body {
            margin-bottom: 0px;
          }
          &.independent-result-body {
            margin-bottom: 24px;
          }
        }
        .question-list-container {
          li:nth-child(even) {
            padding-top: 24px;
          }
          @include media-breakpoint-down(sm) {
            padding-left: 24px;
          }
          .question-list {
            .question-heading {
              font-size: 16px;
              line-height: 24px;
              font-weight: 400;
              color: var(--cup-general-color-5);
              padding-right: 16px;
              .question-sub-heading {
                font-size: 12px;
                line-height: 18px;
                color: var(--cup-general-color-4);
              }
            }
            .question-answer {
              padding-top: 22px;
              padding-right: 24px;
              &.radio-question {
                justify-content: center;
                align-items: center;
                gap: 8px;
                @include media-breakpoint-down(sm) {
                  flex-direction: column;
                  gap: 0px;
                }
              }
              label {
                margin-bottom: 8px;
                cursor: pointer;
                &.checkbox-label {
                  position: relative;
                  padding: 12px 12px 12px 14px;
                  line-height: 20px;
                  font-weight: 700;
                  font-size: 14px;
                  border: 2px solid var(--cup-main-color-3);
                  border-radius: 8px;
                  .checkbox-label-text {
                    padding-left: 16px;
                  }
                  &:before {
                    content: '';
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    border: 2px solid var(--cup-main-color-1);
                    background: transparent;
                    border-radius: 4px;
                    cursor: pointer;
                    position: relative;
                    top: 3px;
                  }
                  &:after {
                    content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='m6.564.75-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3E%3C/svg%3E");
                    display: inline-block;
                    transition: all 0.2s;
                    height: 16px;
                    width: 16px;
                    opacity: 0;
                    transform: scale(0);
                    cursor: pointer;
                    position: absolute;
                    top: 14px;
                    left: 14px;
                  }
                }
                &.radio-label {
                  width: calc(50% - 4px);
                  line-height: 20px;
                  font-weight: 700;
                  font-size: 14px;
                  border: 2px solid var(--cup-main-color-3);
                  border-radius: 8px;
                  padding: 10px;
                  text-align: center;
                  @include media-breakpoint-down(sm) {
                    width: 100%;
                  }
                }
              }
              .radio-input {
                opacity: 0;
                position: absolute;
                z-index: -1;
                &:checked + .radio-label {
                  border-color: var(--cup-main-color-1);
                  background: var(--cup-main-color-1);
                  color: var(--cup-general-color-1);
                }
              }
              .checkbox-input {
                opacity: 0;
                position: absolute;
                z-index: -1;
                &:checked + .checkbox-label {
                  border-color: var(--cup-main-color-1);
                  &:before {
                    background: var(--cup-main-color-1);
                  }
                  &:after {
                    opacity: 1;
                    transform: scale(0.55);
                    color: var(--cup-general-color-1);
                  }
                }
              }
              .checkbox-input:focus-visible + .checkbox-label:before {
                box-shadow: 0 0 0 5px var(--cup-tab-focus-color-2);
                outline: 2px solid var(--cup-tab-focus-color-1);
              }
            }
          }
        }
        .result {
          .loader-wrapper {
            left: calc(50% - 50px);
            position: absolute;
            transform: translate(-50%, -50%);

            .loader {
              border: 12px solid #f3f3f3;
              border-top: 12px solid #ababab;
              border-radius: 50%;
              width: 100px !important;
              height: 100px;
              animation: spin 1s linear infinite;
            }
          }

          .result-heading {
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            text-align: center;
            margin-bottom: 16px;
          }

          .institution-request-icon {
            font-size: 88px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .result-description {
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            padding: 16px 24px 0 24px;
            ul {
              font-weight: 700;
              padding-left: 24px;
              padding-top: 8px;
            }
          }
        }
      }
      .modal-footer {
        border-top: 0 none;
        margin-right: 8px;
        margin-bottom: 8px;

        &.result-footer {
          padding-bottom: 20px !important;
        }
        @include media-breakpoint-down(sm) {
          margin-right: 14px;
          &.result-footer {
            padding-bottom: 0px !important;
          }
        }

        .back-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
          background: none;
          border: none;
          color: var(--cup-main-color-1);
          font-size: 14px;
          gap: 4px;
          letter-spacing: 0.5px;
          line-height: 16px;
          padding: 0 8px 0 8px;
          margin: 20px 0 20px 49px;
          .arrow-left-icon {
            margin: 2px 4px 0 0;
            font-size: 14px;
          }
          @include media-breakpoint-down(sm) {
            margin-left: 30px;
          }
        }

        .next-btn,
        .finish-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
          color: var(--cup-main-color-1);
          font-size: 14px;
          gap: 4px;
          letter-spacing: 0.5px;
          line-height: 16px;
          border-radius: 24px;
          padding: 12px 38px 12px 50px;
          &:disabled {
            cursor: default;
            pointer-events: none;
            color: var(--cup-general-color-3);
            border-color: var(--cup-general-color-3);
          }
          @include media-breakpoint-down(sm) {
            padding-left: 43px;
            padding-right: 31px;
          }
        }

        .finish-btn {
          padding: 12px 34px 12px 46px;
          border: 2px solid var(--cup-main-color-1);
          background: var(--cup-main-color-1);
          color: var(--cup-general-color-1);
          &:disabled {
            color: var(--cup-general-color-1);
            background: var(--cup-general-color-3);
          }
          @include media-breakpoint-down(sm) {
            padding-left: 39px;
            padding-right: 27px;
          }
        }

        .angle-right-icon {
          margin: 2px 0 0 2px;
          font-size: 14px;
        }

        .footer-close-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
          background: none;
          border: none;
          color: var(--cup-main-color-1);
          font-size: 14px;
          letter-spacing: 0.5px;
          line-height: 16px;
          padding: 0 8px 0 8px;
          margin: 20px 0 20px 0;
          .close-icon {
            margin: 2px 6px 0 0;
            font-size: 21px;
          }
        }
      }
    }
  }
}
</style>
